import capitalize from "./component-library317.mjs";
import createCompounder from "./component-library318.mjs";
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});
const camelCase$1 = camelCase;
export {
  camelCase$1 as default
};
